import { render, staticRenderFns } from "./customizationJuriesCard.vue?vue&type=template&id=74c2de72"
import script from "./customizationJuriesCard.vue?vue&type=script&lang=js"
export * from "./customizationJuriesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports